module.exports = __webpack_public_path__ + "img/icon_e63.6c3734ef.png";